<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import TradingViewChart from '@/domains/investor/components/TradingViewChart/TradingViewChart.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorStockQuotes.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorStockQuotes.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorStockQuotes.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorStockQuotes.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorStockQuotes.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorStockQuotes.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <div class="investor-stock-quotes-page">
    <InvestorHero
      class="investor-stock-quotes-page__hero"
      :title="$t('investor.stock.quotes.title')"
      :lead="$t('investor.stock.quotes.description')"
      :main-category="{
        label: $t('investor.stock.quotes.mainCategory.label'),
        url: $t('investor.stock.quotes.mainCategory.url'),
      }"
      :second-category="{
        label: $t('investor.stock.quotes.secondCategory.label'),
        url: $t('investor.stock.quotes.secondCategory.url'),
      }"
      image="/images/investor/stock/stock_research.png"
    />

    <TradingViewChart />
  </div>
</template>
